import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';
import React from 'react';
import { useWorkingHours } from '../../hooks/useSupport';

const ScheduleBlock = styled.div`
  margin-top: 16px;

  i {
    font-size: 15px;
    color: ${Color.BLACK_60};
    line-height: 24px;
  }

  span {
    color: ${Color.BLACK_60};
    line-height: 24px;
  }
`;

const ChatWorkingHours = () => {
  const workingHours = useWorkingHours();

  if (!workingHours) {
    return null;
  }

  return (
    <ScheduleBlock data-testid="chat-working-hours-block">
      <div>
        <i>Chat is available from:</i>
      </div>
      {workingHours.map(wh => {
        return (
          <div key={wh.get('daysStr')}>
            <span>
              {wh.get('daysStr')} <strong>{wh.get('timeStr')}</strong>
            </span>
          </div>
        );
      })}
    </ScheduleBlock>
  );
};

export default ChatWorkingHours;
